export default [
    {
        name: 'driver_sync_app_mobile',
        label: 'labels.driverSyncAppMobile',
        permissionKey: 'driver_sync_app_mobile'
    }
]
